import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SwitchWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 28px;

  input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    background-color: red;
    cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  }

  .slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 6px;
    background-color: #f0f0f0;
    border-radius: 24px;
    border: 1px solid #b0b0b0;
    transition:
      background-color 0.3s,
      border-color 0.3s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 22px;
    width: 22px;
    left: 2px;
    bottom: 50%;
    transform: translateY(50%);
    background-color: #b0b0b0;
    transition:
      transform 0.3s,
      background-color 0.3s;
    border-radius: 50%;
    z-index: 1;
  }

  input:checked + .slider {
    background-color: #fce4e4;
    border-color: #be1622;
  }

  input:checked + .slider:before {
    transform: translateX(22px) translateY(50%);
    background-color: #be1622;
  }

  input:disabled + .slider {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon {
    margin-bottom: 2px;
    position: relative;
    z-index: 1;
    font-size: 14px;
    transition: color 0.3s;
    color: #b0b0b0;
  }

  input:checked + .slider .icon {
    color: #be1622;
  }
`;

const IconToggle = ({ checked, onChange, disabled, leftIcon, rightIcon }) => (
  <SwitchWrapper $disabled={disabled}>
    <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
    <span className="slider">
      <span className="icon">{leftIcon}</span>
      <span className="icon">{rightIcon}</span>
    </span>
  </SwitchWrapper>
);

IconToggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  leftIcon: PropTypes.node.isRequired,
  rightIcon: PropTypes.node.isRequired,
};

export default IconToggle;
